<style lang="less" scoped>
@import "./index.less";
</style>

<template>
  <div class="car-plate-binding">
    <div class="img-wrap">
      <img src="../../../../assets/images/image232.png" width="89" height="87" alt="">
      <div>为了给您更好的行车体验，请准确填写相关信息哦～</div>
    </div>
    <div class="step">
      <div class="step-number">
        <div class="point active"><span>1</span></div>
        <div class="hr"></div>
        <div class="point"><span>2</span></div>
        <div class="hr"></div>
        <div class="point"><span>3</span></div>
      </div>

    </div>
    <div class="plate">
      <div class="title">车牌号录入</div>
      <CarNumberText :plateNumber.sync="plateNumber" @change="plateChange"></CarNumberText>
    </div>
    <div style="text-align: center;"><button :disabled="!carLicense" class="submit" @click="nextStep">下一步</button></div>
    <div style="text-align: center;margin-top: 15px;"><span @click="nextStep" style="font-size: 15px;color: #666;">跳过</span></div>
  </div>
</template>

<script>

import { Field, Form, Popover } from 'vant'
import CarNumberText from "../../../../components/CarNumberText"
export default {
  name: 'home',
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [CarNumberText.name]:CarNumberText
  },
  data() {
    return {
      plateNumber:[],
    }
  },
  computed: {
    carLicense () {
      return this.$store.state.bindData.car_license.split("").length>=7
    },
  },

  mounted () {
    let imei = this.$route.query.imei;
    let sn = this.$route.query.sn;
    this.predictCarInfo(imei,sn)
  },
  methods: {
    plateChange(value){
      this.$store.commit('carPlateHandle', value.join(""))
    },
    predictCarInfo(imei,sn){
      this.$axios.post('/v3/u/user/predictCarInfo',{imei,sn}).then((res) =>{
        const resData = res.data.data;
        this.plateNumber = resData.carLicense?resData.carLicense.split(""): Array(7).fill("")
        this.$store.commit('carPlateHandle',resData.carLicense)

        this.$store.commit('carBrandHandle', {carLogo:resData.carIcon,carBrandName: resData.carBrand})
        this.$store.commit('carModelHandle', {id:resData.carSeriesId, carModelName:resData.carModel})

        this.$store.commit('carRecordHandle', { imei:imei,sn:sn,totalMiles:resData.totalMiles||5,})

      })
    },
    nextStep(){
      this.$router.push("carText");
    }
  }
}
</script>
